// extracted by mini-css-extract-plugin
module.exports = {"galleryPage":"Gallery_galleryPage__1OASC","carouselblue":"Gallery_carouselblue__2eR8j"};